import React from "react";

const MetricsPreview = ({ blockItems }) => {
    return (
        <div className="metrics-cards-grid">
            {blockItems
                .filter((item) => {
                    const title = item?.metricTitle || item?.title || item?.label || "";
                    const value = item?.value || item?.metricValue || "";
                    return String(title).trim().length > 0 || String(value).trim().length > 0;
                })
                .map((item, idx) => {
                    const title = item?.metricTitle || item?.title || item?.label || "";
                    const value = item?.value || item?.metricValue || "";
                    const prefix = item?.prefix || item?.metricPrefix || "";
                    const suffix = item?.suffix || item?.metricSuffix || "";
                    const valuePrefix = prefix && prefix !== "No Prefix" ? prefix : "";
                    const valueSuffix = suffix && suffix !== "No Suffix" ? suffix : "";

                    return (
                        <div className="metric-item-card" key={`${title || "metric"}-${idx}`}>
                            <label>{title}</label>
                            <p>{`${valuePrefix}${value}${valueSuffix}`}</p>
                        </div>
                    );
                })}
        </div>
    );
};

export default MetricsPreview;
